import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retryWhen, mergeMap } from 'rxjs/operators';
import { ConnectionStateService } from './connection-state.service';

@Injectable()
export class ConnectionRetryInterceptor implements HttpInterceptor {
  private readonly MAX_RETRIES = 2; // Reduzido de 3 para 2
  private readonly RETRY_DELAY = 1000; // Reduzido de 2 para 1 segundo
  private readonly RETRY_DELAY_INCREMENT = 500; // Reduzido de 1 segundo para 500ms

  constructor(private connectionStateService: ConnectionStateService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error, index) => {
            // Só tenta novamente se for erro de conexão e não excedeu o limite
            if (this.isConnectionError(error) && index < this.MAX_RETRIES) {
              const delay = this.RETRY_DELAY + (index * this.RETRY_DELAY_INCREMENT);
              console.log(`Retrying request in ${delay}ms (attempt ${index + 1}/${this.MAX_RETRIES})`);
              
              // Retry simples sem verificação de conexão para evitar recursão
              return timer(delay);
            }
            
            // Se não é erro de conexão ou excedeu o limite, propaga o erro
            return throwError(error);
          })
        )
      )
    );
  }

  private isConnectionError(error: HttpErrorResponse): boolean {
    // Erros que indicam problemas de conexão
    const connectionErrorCodes = [0, 408, 500, 502, 503, 504, 522, 524];
    const connectionErrorMessages = [
      'network error',
      'connection refused',
      'timeout',
      'unreachable',
      'failed to fetch',
      'network request failed'
    ];

    // Verifica códigos de erro
    if (connectionErrorCodes.includes(error.status)) {
      return true;
    }

    // Verifica mensagens de erro
    const errorMessage = error.message?.toLowerCase() || '';
    return connectionErrorMessages.some(msg => errorMessage.includes(msg));
  }
}
